<template>
  <button
    class="btn-apply"
    :class="{ disabled: job.displayRaw === 'no' || isDisabled }"
    :disabled="job.displayRaw === 'no' || isDisabled"
    @click="apply"
  >
    <p>I would like to apply this job</p>
    <p>{{ formLabel }}</p>
  </button>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies, { expires: '7d' })

import CryptoJS from 'crypto-js'
const secretKey = 'banana'

export default {
  name: 'JobApplyButton',

  props: {
    job: {
      type: Object,
      default: null,
    },

    token: {
      type: String,
      required: true,
    },

    formLabel: {
      type: String,
      required: true,
    },

    formType: {
      type: String,
      required: true,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    apply() {
      if (this.job.displayRaw === 'no') {
        alert('Job is closed')
        return
      }

      if (this.formType === 'full') {
        const encryptedValue = CryptoJS.AES.encrypt(
          'full',
          secretKey
        ).toString()
        VueCookies.set(this.job.code, encryptedValue)
      } else if (this.formType === 'simple') {
        const encryptedValue = CryptoJS.AES.encrypt(
          'simple',
          secretKey
        ).toString()
        VueCookies.set(this.job.code, encryptedValue)
      }

      window.location.href = `/jobs/${this.job.code}/apply/new/${this.token}`
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

button {
  border: 1px solid #3742fa;
  border-radius: 100rem;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
  padding: 20px 30px;
  text-align: center;

  &.btn-apply {
    background-color: $blue-primary;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  @include sp {
    font-size: 13px;
    margin-top: 10px;
    padding: 10px 15px;
  }
}
</style>
